import { DateTime, Interval } from 'luxon'
import { logWarning } from '@/utils/sentry'

export const getJsDate = jsDateOrDateString => {
  if (typeof jsDateOrDateString === 'string' || jsDateOrDateString instanceof String) {
    return DateTime.fromISO(jsDateOrDateString).toJSDate()
  }
  return jsDateOrDateString
}

export const interval = (start, end = null) => {
  /* istanbul ignore else */
  if (end === null) {
    /* istanbul ignore else */
    if (start instanceof Interval) {
      return start
    }

    const startEmpty = start.start === undefined || start.start === null
    const endEmpty = start.end === undefined || start.end === null

    if (start instanceof Array && start.length === 2) {
      end = start[1]
      start = start[0]
    } else if (start instanceof Object && !startEmpty && !endEmpty) {
      end = start.end
      start = start.start
    } else {
      return Interval.invalid('Invalid start and end values')
    }
  }

  return Interval.fromDateTimes(getJsDate(start), getJsDate(end))
}

export const intervalsOverlap = (intvl1, intvl2, adjacentStart = false, adjacentEnd = false) => {
  intvl1 = interval(intvl1)
  intvl2 = interval(intvl2)

  if (adjacentStart) {
    intvl2 = intvl2.set({ start: intvl2.start.minus({ days: 1 }) })
  }

  if (adjacentEnd) {
    intvl2 = intvl2.set({ end: intvl2.end.plus({ days: 1 }) })
  }
  return intvl1.overlaps(intvl2)
}

export const getFormattedDate = (date, format) => {
  if (!date) return
  return DateTime.fromJSDate(getJsDate(date)).toFormat(format)
}

export const intervalContains = (intvl, date, adjacentEnd = true) => {
  intvl = interval(intvl)
  if (adjacentEnd) {
    if (intvl.end !== undefined && intvl.end !== null) {
      intvl = intvl.set({ end: intvl.end.plus({ days: 1 }) })
    } else {
      logWarning('Invalid interval', {
        interval: intvl,
      })
      return false
    }
  }
  return intvl.contains(getJsDate(date))
}
